// Leg Status Constants
export const LEG_STATUS = {
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  PICKED_UP: 'PICKED_UP',
  IN_TRANSIT: 'IN_TRANSIT',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
};

// Leg Type Constants
export const LEG_TYPE = {
  FIRST_MILE: 'FIRST_MILE',
  MAIN_TRANSPORT: 'MAIN_TRANSPORT',
  LAST_MILE: 'LAST_MILE',
};

// Leg Status Colors for UI
export const LEG_STATUS_COLORS = {
  PENDING: '#9E9E9E', // Gray
  ASSIGNED: '#2196F3', // Blue
  PICKED_UP: '#FF9800', // Orange
  IN_TRANSIT: '#FF9800', // Orange
  COMPLETED: '#4CAF50', // Green
  CANCELLED: '#F44336', // Red
  FAILED: '#F44336', // Red
};

// Leg Status Labels for Display
export const LEG_STATUS_LABELS = {
  PENDING: 'Pending',
  ASSIGNED: 'Assigned',
  PICKED_UP: 'Picked Up',
  IN_TRANSIT: 'In Transit',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
};

// Leg Type Labels for Display
export const LEG_TYPE_LABELS = {
  FIRST_MILE: 'First Mile',
  MAIN_TRANSPORT: 'Main Transport',
  LAST_MILE: 'Last Mile',
};

// Leg Type Icons
export const LEG_TYPE_ICONS = {
  FIRST_MILE: '📦', // Package pickup
  MAIN_TRANSPORT: '🚚', // Truck/transport
  LAST_MILE: '🏠', // Home delivery
};

export default {
  LEG_STATUS,
  LEG_TYPE,
  LEG_STATUS_COLORS,
  LEG_STATUS_LABELS,
  LEG_TYPE_LABELS,
  LEG_TYPE_ICONS,
};
